export default __webpack_public_path__ + "static/media/14.d33c0a1f.png";